import { fg } from '@atlassian/jira-feature-gating';

const isNinIssuePreviewPanelChangeboardingEnabledRelayProvider = {
	get(): boolean {
		return fg('nin_issue_preview_panel_changeboarding');
	},
};

export default isNinIssuePreviewPanelChangeboardingEnabledRelayProvider;
